export class Constants {
  /* ... Default account users ... */
  static readonly USER_TYPE_ADMIN = "Admin";
  static readonly USER_TYPE_SECURITY_PERSONNEL = "Access Terminal Personnel";
  static readonly USER_TYPE_COMMUNITY_MANAGER = "Community Manager";
  static readonly USER_TYPE_RESIDENT = "Resident";

  // START: ... Firebase base location / node path

  static readonly BILL_TYPES_REF = "/billtypes";
  static readonly COMMUNITY_BILL_TYPE_REF = "/community_billtype";
  static readonly PLANS_REF = "/plans";
  static readonly FLEXIBLE_PRICE_DETAIL_REF = "/prices";
  static readonly PROFILE_REF = "/profile";
  static readonly SHIFT_FIREBASE_REF = "/shifts";

  // END: ... Firebase base location / node path

  static readonly PAYMENT_STRUCTURES = [
    { id: "default", name: "Select Payment Structure" },
    { id: "fixed", name: "Fixed" },
    { id: "flexible", name: "Flexible" }
  ];

  static readonly VERIFICATION_STATUS = [
    { name: "Full Payment", id: "full" },
    { name: "Failed", id: "failed" },
    { name: "Pending", id: "pending" }
  ];

  static readonly PART_PAYMENT_STATUS = { name: "Part Payment", id: "part" };

  static readonly PAYMENT_METHODS = [
    { name: "Select Payment Method", id: "default" },
    { name: "Card Payment", id: "card" },
    { name: "Cash Deposit", id: "cash" },
    { name: "Card Payment & Cash Deposit", id: "cash-card" }
  ];

  static readonly BILLING_CYCLES = [
    { name: "Select Billing Cycle", id: "default" },
    { name: "Annually", id: "annually" },
    { name: "Quarterly", id: "quarterly" },
    { name: "Monthly", id: "monthly" },
    { name: "Weekly", id: "weekly" },
    { name: "Daily", id: "daily" },
    { name: "One Off", id: "one-off" }
  ];
  static readonly BILL_TYPE_NOTIFICATION = "billType";
  static readonly PAYMENT_NOTIFICATION = "payment";

  static readonly ENABLE = "enable";
  static readonly DISABLE = "disable";
  static readonly UPDATE = "update";

  static readonly DEFAULT_PASSWORD = "password";
  static readonly genders = ["Female", "Male"];
  static readonly CSV = "text/csv";
  static readonly TSV = "text/tsv";
  static maxFileSize = 5000000;
  static readonly REMINDER_ROLLOUT_TIME = "03:00 a.m.";

  static readonly DAYS_OF_THE_WEEK = {
    Sunday: 0, Monday: 1,
    Tuesday: 2, Wednesday: 3,
    Thursday: 4, Friday: 5,
    Saturday: 6
  };
}



// WEBPACK FOOTER //
// ./src/app/helper/constants.ts